<script setup>
import { computed } from 'vue'
import { trans } from 'laravel-vue-i18n'
import MarkdownEditor from '../editor/MarkdownEditor.vue'

const props = defineProps({
    section: { type: Object, required: true },
})

const emit = defineEmits(['save'])

function handleSave(content) {
    emit('save', { id: props.section.id, content })
}

const metaLabel = computed(() => {
    if (!props.section.updated_at) {
        return ''
    }
    const formatted = new Intl.DateTimeFormat('cs-CZ', {
        day: 'numeric', month: 'numeric', year: 'numeric', hour: '2-digit', minute: '2-digit',
    }).format(new Date(props.section.updated_at))
    return trans('contacts.notebook_updated_at', { date: formatted })
})
</script>

<template>
    <div class="flex-1 flex h-full flex-col gap-2.5 p-3 md:p-4 min-w-0 min-h-0">
        <div class="flex justify-between">
            <p class="font-semibold text-neutral-800 dark:text-neutral-100">{{ section.title }}</p>
            <p v-if="metaLabel" class="text-sm text-neutral-400 dark:text-neutral-500 mt-0.5 tracking-wide">{{ metaLabel }}</p>
        </div>
        <MarkdownEditor
            :key="section.id"
            :model-value="section.content ?? ''"
            autosave
            fill
            class="flex-1 h-full min-h-0"
            :autosave-delay="2000"
            @save="handleSave"
        />
    </div>
</template>
